import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { InfoSolid } from '@bibliocommons/base-icons';
import Popover from '@bibliocommons/popover';
import { Link } from '@bibliocommons/base-links';

import './CreativeCommons.scss';

export default function CreativeCommons({ attribution }) {
  function renderAttributes(source, url) {
    if (source) {
      return url ? (
        <Link dataKey="creative-commons-source-url" href={url}>
          {source}
        </Link>
      ) : (
        <p>{source}</p>
      );
    }
    return null;
  }

  function renderPopoverContent() {
    const sourceTitle = attribution.get('sourceTitle');
    const sourceUrl = attribution.get('sourceUrl');
    const sourceAuthor = attribution.get('sourceAuthor');
    const authorUrl = attribution.get('authorUrl');
    const ccLicenseVersion = attribution.get('ccLicenseVersion');
    const ccLicenseUrl = attribution.get('ccLicenseUrl');
    const modificationMade = attribution.get('modificationMade');

    return (
      <div>
        {renderAttributes(sourceTitle, sourceUrl)}{' '}
        {sourceAuthor && (
          <FormattedMessage id="by_authors" values={{ authorLinks: renderAttributes(sourceAuthor, authorUrl) }} />
        )}
        {(sourceAuthor && ccLicenseVersion) || (sourceTitle && ccLicenseVersion) ? <> / </> : null}
        {renderAttributes(ccLicenseVersion, ccLicenseUrl)}
        {(ccLicenseVersion && modificationMade) ||
        (sourceAuthor && modificationMade) ||
        (sourceTitle && modificationMade) ? (
          <> / </>
        ) : null}
        {renderAttributes(modificationMade)}
      </div>
    );
  }

  return (
    <Popover className="cp-creative-commons" dataKey="creative-commons-container" renderContent={renderPopoverContent}>
      <button className="info-button" type="button">
        <span aria-hidden>
          <InfoSolid />
        </span>
      </button>
    </Popover>
  );
}

CreativeCommons.propTypes = {
  attribution: ImmutablePropTypes.mapContains({
    authorUrl: PropTypes.string,
    ccLicenseUrl: PropTypes.string,
    ccLicenseVersion: PropTypes.string,
    modificationMade: PropTypes.string,
    sourceAuthor: PropTypes.string.isRequired,
    sourceUrl: PropTypes.string
  })
};
